import { defineStore } from 'pinia'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import { ref } from 'vue';
import { saveToken, clearToken, clearProfile } from '@/utils'
import type { Dict, Role } from '@/types'
import { getRolesService, getDictDetailService, searchHospitalService } from '@/api'

export const useAuthStore = defineStore('auth', () => {
  const router = useRouter()
  const dicts = ref<Dict[]>([])
  const roles = ref<Role[]>([])
  const hospitals = ref<{ label: string; value: string }[]>([])

  /** 登出 */
  const logout = () => {
    clearToken()
    clearProfile()

    ElMessage.success('退出登录')
    router.replace('/login')
  }

  const setDicts = (data: Dict[]) => {
    dicts.value = data
  }

  const setRoles = (data: Role[]) => {
    roles.value = data
  }

  const setHospitals = (data: any[]) => {
    hospitals.value = data
  }

  /** 登录 */
  const login = (data: any) => {
    const getDicts = getDictDetailService('100')
    const getRoles = getRolesService()
    const getHospitals = searchHospitalService()

    Promise.all([getDicts, getRoles, getHospitals]).then(([dictsRes, rolesRes, hospitalsRes]) => {
      if (dictsRes.code === '1000') {
        setDicts(dictsRes.data)
      }

      if (rolesRes.code === '1000') {
        setRoles(rolesRes.data)
      }

      if (hospitalsRes.code === '1000') {
        setHospitals(hospitalsRes.data.map((v) => ({ label: v.hospitalName, value: v.sn, ...v })))
      }
    })

    const { token } = data
    const redirectUrl = new URLSearchParams(window.location.search)
      .get('redirectUrl')
      ?.split('?')[0]

    saveToken(token)
    ElMessage.success('登录成功')

    redirectUrl && redirectUrl.startsWith('/') && !redirectUrl.startsWith('/login')
      ? router.replace(redirectUrl)
      : router.replace('/')
  }

  return { login, logout, dicts, roles, hospitals, setDicts, setRoles, setHospitals }
})